module.exports = __webpack_public_path__ + "img/copaAmerica215.420bf0e8.jpg";